<template>
  <div class="vx-col ml-auto mr-auto xl:w-1/2 w-full m-base">
    <vx-card title="Contract verlengen">
      <div v-if="!finished">
        <contract-info
          class="mb-base"
          :contract="contractData"
          :hide-recurring-amount="true"
          v-if="contractData"
        ></contract-info>

        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          errorColor="rgba(var(--vs-danger), 1)"
          :title="null"
          :subtitle="null"
          finishButtonText="Versturen"
          nextButtonText="Volgende"
          backButtonText="Terug"
          @on-complete="onComplete"
        >
          <tab-content
            title="Nieuw contract kiezen"
            class="mb-5"
            icon="feather icon-trending-up"
            :before-change="validateStep1"
          >
            <div class="vx-col  ml-auto mr-auto w-full">
              <!-- tab 1 content -->
              <validation-observer ref="observerStep1">
                <form @submit.prevent="">
                  <vx-card
                    :title="quote.contract_name_quote"
                    v-for="quote in tokenData.quotes"
                    :key="quote.quote_id"
                    class="mb-base"
                    :card-background="
                      proposalData.quoteId != null &&
                      quote.quote_id != proposalData.quoteId
                        ? '#eeeeee'
                        : ''
                    "
                  >
                    <proposal-item :item="quote"></proposal-item>
                    <div class="vx-col w-full mt-5 text-right">
                      <vs-button
                        @click="proposalData.quoteId = quote.quote_id"
                        color="success"
                        :type="
                          proposalData.quoteId == null ||
                          quote.quote_id != proposalData.quoteId
                            ? 'border'
                            : 'filled'
                        "
                        >{{
                          proposalData.quoteId == null ||
                          quote.quote_id != proposalData.quoteId
                            ? "Ik kies dit contract"
                            : "Ik heb dit contract gekozen"
                        }}</vs-button
                      >
                    </div>
                  </vx-card>
                  <ValidationProvider
                    :name="'Een contract kiezen'"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input type="hidden" v-model="proposalData.quoteId" />
                    <div class="text-right">
                      <span class="text-danger m-base ">{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </form>
              </validation-observer>
            </div>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content
            title="Controleren"
            class="mb-5"
            icon="feather icon-check-circle"
          >
            <div class="vx-col  ml-auto mr-auto w-full mt-5">
              <table>
                <tr>
                  <th>Gekozen contract</th>
                  <td>
                    {{ chosenContract.contract_name_quote }}
                  </td>
                </tr>
                <tr>
                  <th style="vertical-align:top;">Omschrijving contract</th>
                  <td>
                    {{ chosenContract.description_contract_website }}
                  </td>
                </tr>
                <tr>
                  <th>Maandbedrag</th>
                  <td>
                    {{ chosenContract.periodic_amount_quote_currency }}
                  </td>
                </tr>
              </table>
            </div>
          </tab-content>
        </form-wizard>
      </div>

      <div v-if="finished">
        <vs-alert color="success" title="Meterstanden" active="true">
          We hebben je verlenging ontvangen. Je ontvangt hier straks een
          bevestiging van in je mail.
        </vs-alert>
      </div>
    </vx-card>
  </div>
</template>

<script>
import contractInfo from "@/components/contractInfo";
import { mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  ValidationObserver,
  extend,
  localize,
  ValidationProvider
} from "vee-validate";

import { required, numeric } from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";
import moment from "moment";
import ProposalItem from "../components/proposal/ProposalItem.vue";
extend("numeric", numeric);
extend("required", required);
localize("nl", nl);
export default {
  data() {
    return {
      serverErrors: null,
      finished: false,
      tokenData: { quotes: [] },
      contractData: null,
      proposalData: {
        quoteId: null
      },
      connectionData: {}
    };
  },
  components: {
    contractInfo,
    FormWizard,
    TabContent,
    ValidationObserver,
    ValidationProvider,
    ProposalItem
  },
  computed: {
    ...mapState(["contracts"]),
    chosenContract() {
      let result = this.tokenData.quotes.find(
        q => q.quote_id == this.proposalData.quoteId
      );
      return result == null ? {} : result;
    }
  },
  props: {
    token: {
      type: String,
      required: true
    }
  },

  watch: {
    token: {
      immediate: true,
      deep: true,
      handler() {
        //this.$router.go();
      }
    }
  },

  methods: {
    async onComplete() {
      try {
        this.proposalData.proposalId = this.token;
        await this.$http().post(`/api/Proposal/accept`, this.proposalData);
        this.finished = true;
      } catch (err) {
        if (err.response && err.response.status == 400) {
          this.serverErrors = err.response.data;
        } else {
          this.showError(
            "Je verlenging kon niet verstuurd worden.",
            false,
            err
          );
        }
      }
    },
    getContractData() {
      if (this.contracts != null) {
        this.contractData = this.contracts.find(
          c => c.id == this.tokenData.contract_id && c.active
        );
      }
    },
    async getRequest() {
      let tokenReq = await this.$http().get(
        `/api/Proposal?proposalId=${this.token}`
      );
      let result = tokenReq.data;

      result.quotes.forEach(element => {
        element.popupActive = false;
      });
      this.tokenData = result;
      this.getContractData();
      this.$store.watch(state => state.contracts, this.getContractData);
    },
    customFormatter(date) {
      return moment(date)
        .locale("nl")
        .format("DD-MM-YYYY");
    },
    async validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.observerStep1.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    }
  },
  async mounted() {
    this.getRequest();
  }
};
</script>

<style></style>
